import { render } from "./Doubt.vue?vue&type=template&id=768cc988&scoped=true"
import script from "./Doubt.vue?vue&type=script&lang=js"
export * from "./Doubt.vue?vue&type=script&lang=js"

import "./Doubt.vue?vue&type=style&index=0&id=768cc988&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768cc988"]])

export default __exports__